import { all } from 'redux-saga/effects'
import tracking from './tracking';
import playing from './playing';
import {
  watchAddBook,
  watchChangeMode,
  watchChangeFrame,
} from './preloading-slides';

export default function* rootSaga() {
  yield all([
    tracking(),
    playing(),
    watchAddBook(),
    watchChangeMode(),
    watchChangeFrame(),
  ])
}


// WEBPACK FOOTER //
// ./src/store/sagas/index.js